// extracted by mini-css-extract-plugin
module.exports = {"grid":"case-grid_grid__2ZlCh","minWidth":"case-grid_minWidth__3_Zrn"};